export const GridAndSpacingHorizontalCenter = `
<div className="mx-auto" style={{width: "200px"}}>
  Centered element
</div>
`
export const GridAndSpacingCssClasses = `
.mt-0 {
margin-top: 0 !important;
}

.ml-1 {
margin-left: 0.25rem !important;
}

.px-2 {
padding-left: 0.5rem !important;
padding-right: 0.5rem !important;
}

.p-3 {
padding: 1rem !important;
}
`
